import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { VARIABLE_REGEX as DOLLAR_SIGN_REGEX } from 'helpers/interpolate';
import { renderMarkdown } from 'helpers/markdown';
import { isBlank } from 'helpers/verify';
import { InterpolateVariables } from 'providers/ContextVariables';
import css from './CmsText.scss';

const ALIGNMENTS = ['left', 'center', 'right'];
const CONTENT_SIZES = ['tiny', 'small', 'regular', 'medium', 'large', 'huge'];

export const CmsText = ({
  alignment,
  className,
  cmsModuleId,
  content,
  shouldIgnoreCache,
  size,
  useDollarSignVariables = false,
}) => {
  if (isBlank(content)) {
    return null;
  }

  // Allows marketing to interpolate variables with $THIS_SYNTAX
  // in addition to {this_syntax}
  const interpolationPattern = useDollarSignVariables ? DOLLAR_SIGN_REGEX : undefined;
  const textClasses = classNames({
    [css[`CmsText--align-${alignment}`]]: ALIGNMENTS.includes(alignment),
    [css[`CmsText--size-${size}`]]: CONTENT_SIZES.includes(size),
    [className]: className,
  });

  return (
    <div className={textClasses}>
      <InterpolateVariables pattern={interpolationPattern}>
        {interpolator => {
          const interpolatedContent = interpolator(content);
          return !shouldIgnoreCache && cmsModuleId && content === interpolatedContent
            ? renderMarkdown(interpolatedContent, `Text:${cmsModuleId}`)
            : renderMarkdown(interpolatedContent);
        }}
      </InterpolateVariables>
    </div>
  );
};

CmsText.propTypes = {
  alignment: PropTypes.oneOf(ALIGNMENTS),
  className: PropTypes.string,
  cmsModuleId: PropTypes.string,
  content: PropTypes.string,
  shouldIgnoreCache: PropTypes.bool,
  size: PropTypes.oneOf(CONTENT_SIZES),
  useDollarSignVariables: PropTypes.bool,
};
